import Vue from 'vue';
import { WorkspaceRPCSession } from '#/services/session';
import { modifyAccountClient } from '#/clients';
import { ProjectDeletionRequest } from '#/protobuf/service_account_pb';
import store from '#/store';

// eslint-disable-next-line import/prefer-default-export
export class ProjectDeleteSession extends WorkspaceRPCSession {
  // we do not derive this from ProjectRPCSession for header reasons
  constructor(projectId) {
    super();
    this.projectId = projectId;
    if (!this.projectId) {
      throw new Error('cannot create a project delete session without a project id');
    }
    this.deletionPromise = undefined; // stores an active promise if one exists for an active deletion
  }

  // we aren't necessarily deleting the active project so we didn't want the ProjectRPC projections
  async headers() {
    try {
      const metadata = await super.headers(); // begin with parent class headers.
      metadata.project = this.projectId;
      return Promise.resolve(metadata);
    } catch (error) {
      console.error('error retrieving project headers', error);
      this.error = error;
      return Promise.reject(error);
    }
  }

  // TODO: project confirmation name!!!
  async deleteProject(confirmedProjectName) {
    if (this.deletionPromise) {
      return this.deletionPromise;
    }
    const headers = await this.headers();
    const request = new ProjectDeletionRequest();
    request.setUserConfirmation(confirmedProjectName);
    console.info('DELETING....', confirmedProjectName);
    this.deletionPromise = new Promise((resolve, reject) => {
      modifyAccountClient.deleteProject(request, headers, (err, response) => {
        if (err != null) {
          console.log('received err from deleteProject ', err);
          this.error = err;
          return reject(err);
        }
        console.log('deleted project: ', this.projectId);

        return resolve(response);
        // TODO: commit mutation
        // return resolve(response.toObject());
      });
    }).finally(() => {
      this.deletionPromise = undefined; // TODO: remove from store
    });
    return this.deletionPromise;
  }

  // catch(error) {
  //   console.log('caught error loading job page:', error);
  //   this.error = error;
  //   return Promise.reject(error);
  // }
}
